import { Trash2 } from 'lucide-react';
import type { CaseRole, Invitation } from '@casetrace/shared';
import { Button } from '../../components/ui/button';

type PendingInvitationsListProps = {
  readonly invitations: Invitation[];
  readonly canDelete?: boolean;
  readonly isDeleting?: boolean;
  readonly onDelete?: (invitationId: Invitation['id']) => void;
};

const ROLE_LABELS: Record<CaseRole, string> = {
  owner: 'Eier',
  member: 'Medlem',
  viewer: 'Leser',
};

export function PendingInvitationsList({
  invitations,
  canDelete = false,
  isDeleting = false,
  onDelete,
}: PendingInvitationsListProps) {
  return (
    <section>
      <h3 className="mb-2 text-[10px] font-semibold uppercase tracking-widest text-[#3e404e]">
        Ventende invitasjoner
      </h3>
      {invitations.length === 0 ? (
        <p className="text-xs text-text-tertiary">Ingen ventende invitasjoner.</p>
      ) : (
        <div className="flex flex-col gap-2">
          {invitations.map((invitation) => (
            <div
              key={invitation.id}
              className="flex items-center justify-between gap-2 rounded-md bg-white/4 px-3 py-2"
            >
              <p className="min-w-0 truncate text-xs text-text-secondary">
                {invitation.email} · {ROLE_LABELS[invitation.role]}
              </p>
              {canDelete && onDelete && (
                <Button
                  className="shrink-0 px-2 py-1 text-xs text-danger/80"
                  variant="ghost"
                  disabled={isDeleting}
                  aria-label={`Slett invitasjon til ${invitation.email}`}
                  onClick={() => onDelete(invitation.id)}
                >
                  <Trash2 size={12} />
                </Button>
              )}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
